/**
 * Check if element is a node list
 *
 * @param  {HTMLElement|HTMLCollection|NodeList} el Element to check
 * @return {Boolean}
 */
const IsNodeList = (el) => {
    const stringRepr = Object.prototype.toString.call(el)

    return typeof el === 'object' &&
    /^\[object (HTMLCollection|NodeList|RadioNodeList|Object)\]$/.test(stringRepr) &&
    (typeof el.length === 'number') &&
    (el.length === 0 || (typeof el[0] === 'object' && el[0].nodeType > 0))
}

export default IsNodeList
